






































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {ActionsEnum} from "@/entity/ActionsEnum";

@Component({})
export default class SsoUserPicker extends Vue {
  @Prop() value!: any;
  @Prop() rules!: string;

  isLoading: boolean = false;
  items: Array<any> = [];

  userInput(value: any) {
    this.$emit('object-data', this.items.find(item => item.sso_user_id == value));
    this.$emit('input', value)
  }

  mounted() {
    this.load();
  }

  async load() {
    try {
      this.isLoading = true;
      let res: Array<any> = (await this.$http.get(ActionsEnum.Users)).data;
      this.items = res.filter(item => item.sso_user_id != null);
    } catch (e) {
      console.error(e)
    } finally {
      this.isLoading = false;
    }
  }
}
